import { vehicleKey, type PlateSighting } from '@iot-dashboard/shared';

/** A read, or a row of the Vehicles tab, as far as naming it goes. */
type Vehicle = Pick<PlateSighting, 'plate' | 'vehicleName' | 'plateSource'> & { rawPlate?: string };

/** What a vehicle is called on screen: its plate, or its name in Protect until a plate is saved for it. */
export function plateLabel(v: Vehicle): string {
  if (v.plateSource === 'name') return v.vehicleName ?? v.plate;
  return v.rawPlate || v.plate;
}

/** The name to show beside a plate, unless it is only the plate again. */
export function nameBesidePlate(v: Vehicle): string | undefined {
  if (v.plateSource === 'name' || !v.vehicleName) return undefined;
  return vehicleKey(v.vehicleName) === v.plate ? undefined : v.vehicleName;
}

/**
 * The search that finds every read of a vehicle. A vehicle known only by name
 * is searched by that name, which reads better in the box than its stand-in.
 */
export function vehicleSearch(v: Vehicle): string {
  return v.plateSource === 'name' && v.vehicleName ? v.vehicleName : v.plate;
}
